export default "__VITE_ASSET__DWHP0z_h__"